import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Calendar, Coins, Loader2, PenLine } from 'lucide-react'
import { pointsApi } from '../../lib/api'

const MedicalDashboard = () => {
  const [staff, setStaff] = useState<any>(null)
  const [todayUsers, setTodayUsers] = useState(0)
  const [todayPoints, setTodayPoints] = useState(0)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const raw = localStorage.getItem('medicalUser')
    if (raw) {
      try { setStaff(JSON.parse(raw)) } catch { /* ignore */ }
    }

    const load = async () => {
      try {
        const statsResp = await pointsApi.todayStats() as any
        setTodayUsers(statsResp.today_users || 0)
        setTodayPoints(statsResp.today_points || 0)
      } catch (e) {
        console.error('Failed to load dashboard', e)
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [])

  const getRoleLabel = (role: string) => {
    switch (role) {
      case 'doctor': return '医生'
      case 'nurse': return '护士'
      case 'supervisor': return '机构负责人'
      default: return '医护'
    }
  }

  return (
    <div className="space-y-6">
      {/* 欢迎信息 */}
      <div className="bg-gradient-to-r from-green-600 to-green-700 rounded-2xl p-6 text-white">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <h1 className="text-2xl font-bold">
              你好，{staff?.name || '医护'}
              {staff?.role ? ` · ${getRoleLabel(staff.role)}` : ''}
            </h1>
            <p className="text-green-100 mt-1">{staff?.hospital || '医护端'}</p>
          </div>
          <div className="flex items-center space-x-4">
            <div className="bg-white/20 backdrop-blur-sm rounded-xl px-4 py-2">
              <p className="text-sm text-green-100">今日服务人数</p>
              <p className="text-xl font-bold">
                {loading ? <Loader2 className="w-4 h-4 animate-spin inline" /> : `${todayUsers} 人`}
              </p>
            </div>
            <div className="bg-white/20 backdrop-blur-sm rounded-xl px-4 py-2">
              <p className="text-sm text-green-100">今日分发积分</p>
              <p className="text-xl font-bold">
                {loading ? <Loader2 className="w-4 h-4 animate-spin inline" /> : `${todayPoints} 分`}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* 快捷操作入口 */}
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        <Link to="/medical/point-entry"
          className="bg-white rounded-2xl shadow-md p-6 hover:shadow-lg transition-shadow group">
          <div className="w-14 h-14 bg-green-100 group-hover:bg-green-600 rounded-xl flex items-center justify-center mb-4 transition-colors">
            <Coins className="w-7 h-7 text-green-600 group-hover:text-white transition-colors" />
          </div>
          <h3 className="font-bold text-gray-800">积分录入</h3>
          <p className="text-sm text-gray-500 mt-1">搜索用户录入积分</p>
        </Link>

        <Link to="/medical/events"
          className="bg-white rounded-2xl shadow-md p-6 hover:shadow-lg transition-shadow group">
          <div className="w-14 h-14 bg-teal-50 group-hover:bg-teal-600 rounded-xl flex items-center justify-center mb-4 transition-colors">
            <Calendar className="w-7 h-7 text-teal-600 group-hover:text-white transition-colors" />
          </div>
          <h3 className="font-bold text-gray-800">事件列表</h3>
          <p className="text-sm text-gray-500 mt-1">查看可用积分事件</p>
        </Link>

        {/* 图文投稿：进入「我的投稿」，可查看草稿/审核状态并新建投稿 */}
        <Link to="/medical/author"
          className="bg-white rounded-2xl shadow-md p-6 hover:shadow-lg transition-shadow group">
          <div className="w-14 h-14 bg-blue-50 group-hover:bg-blue-600 rounded-xl flex items-center justify-center mb-4 transition-colors">
            <PenLine className="w-7 h-7 text-blue-600 group-hover:text-white transition-colors" />
          </div>
          <h3 className="font-bold text-gray-800">图文投稿</h3>
          <p className="text-sm text-gray-500 mt-1">撰写科普投稿，查看审核进度</p>
        </Link>
      </div>
    </div>
  )
}

export default MedicalDashboard
